import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Editor from "@/editor/Editor.jsx";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/editor/theme/ThemeProvider.jsx";

const isGitHubProjectPage = window.location.pathname.startsWith('/svg-studio');
const basename = isGitHubProjectPage ? '/svg-studio' : '';

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
        <BrowserRouter basename={basename}>
          <Routes>
            <Route path="/" element={<Editor />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </ThemeProvider>
  );
}

export default App;
